import { Box, Grid, Text } from '@chakra-ui/react'
import * as React from 'react'
import { useHistory } from 'react-router'
import cx from 'classnames'
import styles from './sidebar-card.module.less'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon'
import { handleKeyDown } from 'src/utils/helpers'

export const SidebarCard = props => {
  const {
    title,
    children,
    icon,
    active,
    onClick,
    item,
    isColumnReverse,
    isColumn,
    avatarCircle,
    isFullWidth,
    isProfile,
    noMargin,
    size,
    isMainMenu,
    isServices,
    preTitle,
    disabled,
    isOverflown,
    hidden,
  } = props
  const history = useHistory()
  const isActive = active === item.id && !history.location.pathname.includes('welcome')
  const classNames = cx({
    [styles.sidebarCardContainer]: true,
    [styles.sidebarCardContainerActive]: isActive && isMainMenu,
    'kiosk--chakra-colors-card-column-active': isColumnReverse && item.checked,
    'kiosk--chakra-colors-card-background': true,
    [styles[size]]: size,
  })
  const classNamesSidebarCard = cx({
    [styles.sidebarCard]: true,
    'kiosk--chakra-colors-background-accent': !isColumn && !isColumnReverse && isActive,
    'kiosk--chakra-colors-card-background': isColumn || isColumnReverse,
    [styles.fullWidth]: isFullWidth,
    [styles.noMargin]: noMargin,
    [styles.sidebarCardColumnContainer]: isColumn && isColumnReverse,
    [styles.sidebarCardColumnNoReverseContainer]: isColumn && !isColumnReverse,
    [styles.sidebarCardDisabled]: disabled,
  })

  if (hidden) {
    return <></>
  }

  const handleClick = evt => {
    if (item.url === '/auth/login') {
      history.push({
        pathname: item.url,
        state: {
          listItem: item,
        },
      })
    } else {
      onClick(evt)
    }
  }

  return (
    <Box className={classNamesSidebarCard} onClick={handleClick} variant='card'>
      <Box className={classNames}>
        {icon ? (
          isColumn ? (
            <Box my={'10px'}>{icon}</Box>
          ) : (
            <Box
              className={isProfile || isServices ? '' : 'kiosk--chakra-colors-icon-container'}
              display='flex'
              justifyContent='center'
              alignItems='center'
              fontSize='2xl'
              color='gray.500'
              w='52px'
              h='52px'
              minW='52px'
              mr={18}
              borderRadius={avatarCircle ? '100%' : '5px'}
            >
              {icon}
            </Box>
          )
        ) : null}
        <Grid flex='1' ml={{ base: isColumn ? '20px' : '0', desktop: 0 }} width={'inherit'}>
          <Box>
            {preTitle ? (
              <Text
                opacity={0.7}
                wordBreak={'break-word'}
                pr={{
                  desktop: isMainMenu || isProfile ? '20px' : '0',
                  base: isMainMenu || isProfile || isOverflown ? '20px' : '',
                }}
                lineHeight={'23px'}
                color='brand.card-font'
                align={{ desktop: isColumn ? 'center' : '' }}
                fontSize={'11px'}
                fontWeight='500'
              >
                {preTitle}
              </Text>
            ) : null}
            <Text
              wordBreak={'break-word'}
              pr={{
                desktop: isMainMenu || isProfile ? '20px' : '0',
                base: isMainMenu || isProfile || isOverflown ? '20px' : '0',
              }}
              lineHeight={'23px'}
              color='brand.card-font'
              align={{ desktop: isColumn ? 'center' : '' }}
              fontSize={isColumn ? 20 : 18}
              fontWeight='500'
              tabIndex='0'
              fg
              onKeyDown={handleKeyDown(handleClick)}
            >
              {title}
            </Text>
          </Box>
          <Text
            wordBreak={'break-word'}
            pr={{
              desktop: isMainMenu || isProfile ? '20px' : '0',
              base: isMainMenu || isProfile || isOverflown ? '20px' : '0',
            }}
            lineHeight={'17px'}
            className={cx({
              [styles.mainMenuCard]: isMainMenu || isProfile,
              [styles.profileCardOverflow]: isProfile,
              [styles.overflowMobile]: isOverflown,
            })}
            fontSize={{ base: '13px' }}
            variant={item.errorMessage ? 'error' : 'card'}
            align={{ desktop: isColumn ? 'center' : '' }}
            opacity={item.errorMessage ? '1' : '0.6'}
          >
            {item.errorMessage ? item.errorMessage : children}
          </Text>
        </Grid>
      </Box>
      {item.hideArrowAlways ? null : (
        <Box
          pos='absolute'
          minH={'24px'}
          right={'16px'}
          top={item.customRightIconShift ? '15px' : '35%'}
          display={{
            desktop: `${item.hideArrow ? 'none' : 'flex'}`,
            base: `${item.hideArrowOnMobile ? 'none' : ''}`,
          }}
          alignItems={'center'}
        >
          {item.customRightIcon ? (
            item.customRightIcon()
          ) : (
            <FontAwesomeIconComponent
              icon={['fal', 'angle-right']}
              size='xs'
              type={isActive ? 'card' : 'card-font'}
            />
          )}
        </Box>
      )}
    </Box>
  )
}
